import { LinkModel } from '../../Forms/models/link.model';
import { BriefingImageDisplayElementApiModel } from '../../../api/briefings/model/briefing-image-display-element-api.model';

export class BriefingImageSettingsModel {
    declare link: LinkModel;

    caption: string = null;
    altText: string = null;
    displaySize: number = null;

    constructor(apiModel?: BriefingImageDisplayElementApiModel) {
        if (apiModel) {
            if (apiModel.imageProperties) {
                const {caption = null, altText = null, displaySize = null } = apiModel.imageProperties;
                // in https://phabricator.agilitypr.internal/D18249, we intentionally set null as default value
                // Thus, here we make it consistent, otherwise, when converting distribution to wire, it may cause unsaved change bug
                this.caption = caption;
                this.altText = altText;
                this.displaySize = displaySize;
            }

            if (apiModel.link) {
                this.link = new LinkModel(apiModel.link);
            }
        }
    }

    toApi(): any {
        const api = {
            imageProperties: {
                caption: this.caption,
                altText: this.altText,
                displaySize: this.displaySize,
            },
            link: this.link?.toApi()
        };

        return api;
    }

    clone(): BriefingImageSettingsModel {
        const apiModel = this.toApi();
        const clone = new BriefingImageSettingsModel(apiModel);

        return clone;
    }
}
